<div class="wrap" [ngClass]="{'edit-tab-active': selectedIndex === 0 && !data.removeEditTab, 'edit-tab-removed': data.removeEditTab, 'panel-open': imagesOpen}">
        <h2>Images</h2><button type="button" class="close" [mat-dialog-close]="data.image"><mat-icon>close</mat-icon></button>
        <div id="panel-toggle">
            <span class="icon-button" (click)="toggle('imagesOpen')" [ngClass]="{active: imagesOpen}">
                <mat-icon>insert_photo</mat-icon> 
            </span>
        </div>
        <div class="left-col">
            <button *ngIf="!data.adsTab" type="button" class="popout faded" (click)="gettyService.openPopout()"><mat-icon>launch</mat-icon></button>
            <mat-tab-group 
                class="tabs" 
                #group 
                [dynamicHeight]="true" 
                [(selectedIndex)]="selectedIndex" 
                (selectedTabChange)="toggleTabContent()">
                <mat-tab label="Edit" [disabled]="!data.image" *ngIf="!data.removeEditTab">
                    <image-details-component 
                        *ngIf="showImageDetails"
                        [canEdit]="data.canEdit" 
                        [(image)]="data.image"
                        [addToSlide]="data.addToSlide"
                        (done)="done($event)"
                        [dialog]="true"
                        [quiz]="data.quiz"
                        [adsTab]="data.adsTab"
                        [mustAddDetails]="data.mustAddDetails">
                    </image-details-component>
                </mat-tab>
                <mat-tab label="Getty" *ngIf="!data.adsTab">
                    <getty-images 
                        *ngIf="showGettySearch"
                        [id]="slideshow.assignment.id" 
                        [canEdit]="!slideshow.locked"
                        [addToSlide]="data.addToSlide"
                        [quiz]="data.quiz" 
                        [removeEditButton]="data.removeEditTab"
                        (imageDownloaded)="downloadAction($event)">
                    </getty-images>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="right-col" [ngClass]="{open: imagesOpen}">
            <image-list (imageClick)="selectImage($event)" [dialog]="true"></image-list>
        </div>
</div>